// src/components/Dashboard/WelcomeSection.tsx
import React from 'react';

const WelcomeSection: React.FC = () => {
  return (
    <section className="welcome-section">
      <h2>Добро пожаловать в систему управления роботами!</h2>
      <p>Выберите раздел для работы:</p>
    </section>
  );
};

export default WelcomeSection;